import { Button, message, Upload } from 'antd';
import { CameraOutlined } from '@ant-design/icons';
import ImgCrop from 'antd-img-crop';
import { useMutation } from '@apollo/client';
import { UPLOAD } from '../../../graphql/upload';
import { UPDATE_CLIENT } from '../../../graphql/client';
import { UPDATE_PARENT } from '../../../graphql/parent';

export function ModalAvatar({ client, type, onUpdate }) {

    const [upload, uploadData] = useMutation(UPLOAD);
    const [update, updateData] = useMutation(type === 'child' ? UPDATE_CLIENT : UPDATE_PARENT);

    return (
        <ImgCrop aspect={1} cropShape={'round'} modalTitle={'Обрежьте фото'} modalOk={'Готово'} modalCancel={'Отмена'}>
            <Upload accept={'image/*'} maxCount={1} showUploadList={false}
                    customRequest={async ({ file }) => {
                        try {
                            await upload({
                                variables: { file: file },
                                onCompleted: async (res) => {
                                    await update({
                                        variables: {
                                            id: client.id,
                                            data: {
                                                avatar: res.upload.data.id,
                                            }
                                        },
                                        onCompleted: () => {
                                            onUpdate();
                                        }
                                    })
                                }
                            });
                        } catch (error) {
                            message.error(error.message);
                            console.error(error);
                            return false;
                        }
                    }}
            >
                <Button loading={uploadData.loading || updateData.loading} type={'link'} icon={<CameraOutlined />}>
                    Аватарка
                </Button>
            </Upload>
        </ImgCrop>
    );
}
